// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"386":"0d54484b","487":"d0a4cb7a"}[chunkId] + ".chunk.css";
};